export default __webpack_public_path__ + "static/media/twitter-solid.2a07ecee.svg";